import { render, staticRenderFns } from "./Parceria_Sechs.vue?vue&type=template&id=5c1c1c1a"
import script from "./Parceria_Sechs.vue?vue&type=script&lang=js"
export * from "./Parceria_Sechs.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sechs.vue?vue&type=style&index=0&id=5c1c1c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports